import {
    AutocompleteResponse,
    NavigationResponse,
    NavigationSearchResponse,
    SearchbannersResponse,
    type SuggestionAPIResponse,
    TweakwiseItem,
} from "@jog/types"

import { AWSClient } from "./index"

export const tweakwiseClient = () => AWSClient(process.env.NEXT_PUBLIC_AWS_TWEAKWISE_ENDPOINT || "")
export const synchronousClient = () => AWSClient(process.env.NEXT_PUBLIC_AWS_SYNCHRONOUS_ENDPOINT || "")
const CHANNEL = process.env.NEXT_PUBLIC_WEBSHOP!
const LANGUAGE = process.env.NEXT_PUBLIC_LOCALE!

export const navigation = (search: string | URLSearchParams) =>
    tweakwiseClient()<NavigationResponse>({
        uri: `/navigation?channel=${CHANNEL}&language=${LANGUAGE}&${search}`,
        method: "GET",
    })

export const suggestions = (search: string) =>
    tweakwiseClient()<SuggestionAPIResponse>({
        uri: `/suggestions?channel=${CHANNEL}&language=${LANGUAGE}&tn_q=${search}&tn_cid=${process.env.NEXT_PUBLIC_TW_ROOT_CATEGORY_ID}`,
        method: "GET",
    })

/**
 * @deprecated This endpoint is deprecated and has been replaced by Suggestions.
 */
export const autocomplete = (searchWord: string) =>
    tweakwiseClient()<AutocompleteResponse>({
        uri: `/autocomplete?channel=${CHANNEL}&language=${LANGUAGE}&tn_q=${searchWord}&tn_cid=${process.env.NEXT_PUBLIC_TW_ROOT_CATEGORY_ID}`,
    })

export const getGroup = (groupId: string) =>
    tweakwiseClient()<Record<string, TweakwiseItem[]>>({
        uri: `/navigation-grouped?channel=${CHANNEL}&language=${LANGUAGE}&parent=${groupId}&template=${process.env.NEXT_PUBLIC_COLOR_VARIANTS_TEMPLATE}`,
        method: "GET",
    }).then((res) => res.body)

export const navigationSearch = (search: string | URLSearchParams) =>
    tweakwiseClient()<NavigationSearchResponse & { searchbanners: SearchbannersResponse }>({
        uri: `/navigation-search?channel=${CHANNEL}&language=${LANGUAGE}&${search}`,
        method: "GET",
    })

export const getSoftPageUrls = () =>
    synchronousClient()<{ softPageUrls: Record<string, string>[][] }>({ uri: `/soft-page-urls`, method: "GET" })
